<template>
    <div class="initial-loader">
        <div></div><div></div><div></div><div></div>
    </div>
</template>

<script>

const componentLoading = {
    name: 'componentLoading',
    mounted() {
        // eslint-disable-next-line camelcase
        if (typeof vueSlowConnectionDetected !== 'undefined' && vueSlowConnectionDetected && typeof lib_showAjaxLoadingIndicator === 'function') {
            lib_showAjaxLoadingIndicator('body', false, false, false, 'initialLoader');
        }
    },
    unmounted() {
        // eslint-disable-next-line camelcase
        if (typeof vueSlowConnectionDetected !== 'undefined' && vueSlowConnectionDetected && typeof lib_showAjaxLoadingIndicator === 'function') {
            setTimeout(() => {
                let currentLoading = document.getElementsByClassName('initial-loader').length;
                if (currentLoading === 0) {
                    let initialLoader = document.getElementById('initialLoader');
                    if (initialLoader) {
                        initialLoader.style.display = 'none';
                    }
                }
            }, 1000);
        } else {
            setTimeout(() => {
                let currentLoading = document.getElementsByClassName('component-loader').length;
                if (currentLoading === 0) {
                    let initialLoader = document.getElementById('initialLoader');
                    if (initialLoader) {
                        initialLoader.style.display = 'none';
                    }
                }
            }, 1000);
        }
    }
};

export default componentLoading;
</script>

<style scoped>
.initial-loader {
    display: inline-block;
    position: fixed;
    z-index: 9999999;
    width: 80px;
    height: 80px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.initial-loader div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 40px;
    height: 40px;
    margin: 8px;
    border: 4px solid #1976d2;
    border-radius: 50%;
    animation: initial-loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1976d2 transparent transparent transparent;
}
.initial-loader div:nth-child(1) {
    animation-delay: -0.45s;
}
.initial-loader div:nth-child(2) {
    animation-delay: -0.3s;
}
.initial-loader div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes initial-loader {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

body ~ .initial-loader {
    display: none;
}

body ~ .initial-loader:first-child {
    display: block;
}
</style>
